import fetch from '@/api/fetch'

/** 查询工种工资列表 */
export const getWageWorkTypeList = params => fetch.get('/sys/wage/list', { params });

/** 新增或修改 */
export const saveOrUpdateWageWorkType = wageWorkType => fetch.post('/sys/wage/save', wageWorkType);

/** 删除 */
export const deleteWageWorkType = id => fetch.delete(`/sys/wage/delete/id/${id}`);

/** 导出工种工资 */
export const exportWageWorkType = params => fetch.get('/sys/wage/export', {params,  responseType: 'blob'})
